module.exports = "https://cdn.realtymogul.com/static/media/multifamily_strategy.0086c28c.jpg";